import React from 'react';
import PropTypes from 'prop-types';
import { format, parse } from 'date-fns';
import { ja } from 'date-fns/locale';

const getUpdateTimeDisplay = (dataUpdateTime) => {
  if (!dataUpdateTime) {
    return '';
  }

  const updateTime = parse(dataUpdateTime, 'yyyy/MM/dd HH:mm:ss', new Date());
  return format(updateTime, 'yyyy年M月d日（eee） hh:mm', { locale: ja });
};

const DataUpdateTimeDisplay = ({ className, dataUpdateTime, showUpdateNote }) => {

  return (
    <div className={`dataUpdateTimeDisplay ${className}`}>
      ※旅行代金は往復航空機＋宿泊代金となります。<br/>
      {showUpdateNote && (
        <span>
          ※表示されている旅行代金・プラン内容は一定時間ごとに更新されます。<br/>
          最終確認画面でご確認ください。<br/>
        </span>
      )}
      {dataUpdateTime && (
        <span>空室状況：{getUpdateTimeDisplay(dataUpdateTime)}現在</span>
      )}
    </div>
  );
};

DataUpdateTimeDisplay.defaultProps = {
  className: '',
  showUpdateNote: false,
};

DataUpdateTimeDisplay.propTypes = {
  className: PropTypes.string,
  dataUpdateTime: PropTypes.string,
  showUpdateNote: PropTypes.bool,
};

export default DataUpdateTimeDisplay;
